import { useState } from "react";
import type { FormEvent } from "react";
import { mensagemDoConsole } from "../../nucleo/console";
import {
  useAdicionarTag,
  useRemoverTag,
  useTagsDoChamado,
  useTagsEmUso,
} from "../../nucleo/tickets-operacao";
import { Aviso, Botao, Campo, Cartao } from "../ui";

/** Tags livres e internas do chamado. O cliente nunca as vê (a API nem as entrega a ele). */
export function EtiquetasDoChamado({ ticketId }: { ticketId: string }) {
  const tags = useTagsDoChamado(ticketId);
  const emUso = useTagsEmUso();
  const adicionar = useAdicionarTag(ticketId);
  const remover = useRemoverTag(ticketId);
  const [nova, setNova] = useState("");

  function incluir(evento: FormEvent) {
    evento.preventDefault();
    adicionar.mutate(nova.trim(), { onSuccess: () => setNova("") });
  }

  return (
    <Cartao titulo="Tags" className="mb-4" data-testid="tags-do-chamado">
      {tags.isPending ? (
        <p role="status">Carregando tags…</p>
      ) : tags.isError ? (
        <Aviso tom="erro">{mensagemDoConsole(tags.error)}</Aviso>
      ) : (
        <ul className="flex flex-wrap gap-2 mb-3" aria-label="Tags do chamado">
          {tags.data.tags.length === 0 ? <li className="nota-rodape">Nenhuma tag neste chamado.</li> : null}
          {tags.data.tags.map((tag) => (
            <li className="chip chip--neutro" key={tag}>
              <span>{tag}</span>
              <button
                type="button"
                className="ml-2"
                aria-label={`Remover a tag ${tag}`}
                onClick={() => remover.mutate(tag)}
                disabled={remover.isPending}
              >
                ×
              </button>
            </li>
          ))}
        </ul>
      )}
      <form className="flex flex-wrap items-end gap-3" onSubmit={incluir}>
        <Campo
          rotulo="Nova tag"
          ajuda="Só a equipe vê. Até 20 por chamado."
          value={nova}
          onChange={(evento) => setNova(evento.target.value)}
          maxLength={40}
          list={`tags-em-uso-${ticketId}`}
        />
        <datalist id={`tags-em-uso-${ticketId}`}>
          {emUso.data?.map((item) => <option value={item.tag} key={item.tag} />)}
        </datalist>
        <Botao type="submit" variante="fantasma" disabled={!nova.trim() || adicionar.isPending}>
          Adicionar tag
        </Botao>
      </form>
      {adicionar.isError ? <Aviso tom="erro" className="mt-3">{mensagemDoConsole(adicionar.error)}</Aviso> : null}
      {remover.isError ? <Aviso tom="erro" className="mt-3">{mensagemDoConsole(remover.error)}</Aviso> : null}
    </Cartao>
  );
}

/** Filtro da fila por tag, com as tags em uso como sugestão. */
export function FiltroDeTag({ valor, aoMudar }: { valor: string; aoMudar: (valor: string) => void }) {
  const emUso = useTagsEmUso();
  return (
    <div>
      <Campo
        rotulo="Filtrar por tag"
        value={valor}
        onChange={(evento) => aoMudar(evento.target.value)}
        list="tags-da-fila"
        placeholder="Ex.: bug erp"
      />
      <datalist id="tags-da-fila">
        {emUso.data?.map((item) => <option value={item.tag} key={item.tag}>{item.chamados}</option>)}
      </datalist>
    </div>
  );
}
